import HeroSection from "../Components/HeroSection/HeroSection";
import AboutSection from "../Components/AboutSection/AboutSection";
import TechStack from "../Components/TechStack/TechStack";
import BrandSection from "../Components/BrandsSection/BrandSection";
import HorizontalScroll from "../Components/HorizontalScroll/HorizontalScroll";
//import FaqSection from "../Components/FaqSection/FaqSection";

import LatestProject from "../Components/LatestProject/LatestProject";
import FullWidthBanner from "../Components/FullWidthBanner/FullWidthBanner";

import Footer from "../Components/Layout/Footer/Footer";

import ScreenImage from "../Assets/Misc/movies.webp";

const HomePage = () => {
  return (
    <>
      <HeroSection />
      <AboutSection />
      <LatestProject
        isSwiched={true}
        title="Trailerify"
        content="Trailerify is a web platform with movies and TV shows content, it is created for those who understand what it means to be passionate about cinematography. Deciding what movie or TV show to watch usually takes time. Is better to watch trailer first"
        buttonTitle="Live Preview"
        linkTo="http://trailerify.vercel.app"
        screenImage={ScreenImage}
        bgImage="https://images.unsplash.com/photo-1618423771949-1de4842d5858?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1274&q=80"
      />
      <HorizontalScroll />
      <BrandSection />
      <FullWidthBanner />
      <TechStack />
      <Footer />
      {/* <FaqSection /> */}

      {/* </SmothScroll> */}
    </>
  );
};

export default HomePage;
